import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import AnnouncementPageId from "@mapmycustomers/shared/enum/announcements/AnnouncementPageId";
import Announcement from "@mapmycustomers/shared/types/announcements/Announcement";

import AnnouncementsTrigger from "@app/types/AnnouncementsTrigger";

export const fetchAnnouncements = createAsyncAction(
  "@announcements/fetchAnnouncements/request",
  "@announcements/fetchAnnouncements/success",
  "@announcements/fetchAnnouncements/failure"
)<void, Announcement[], void>();

// Freezes the queue and the page the modal shows, so announcements arriving later never mutate it.
export const openAnnouncements = createAction("@announcements/openAnnouncements")<{
  pageId: AnnouncementPageId | undefined;
  queue: Announcement[];
  trigger: AnnouncementsTrigger;
}>();

// The user arrived on another page, which may show announcements.
export const triggerAnnouncements = createAction("@announcements/triggerAnnouncements")();

// The pending trigger had nothing to show.
export const skipAnnouncements = createAction("@announcements/skipAnnouncements")();

export const showNextAnnouncement = createAction("@announcements/showNextAnnouncement")<
  Announcement["id"]
>();

export const postponeAnnouncement = createAction("@announcements/postponeAnnouncement")<
  Announcement["id"]
>();

// Hides announcements until a page reload or sign-out.
export const hideAnnouncements = createAction("@announcements/hideAnnouncements")();

export const resetAnnouncements = createAction("@announcements/resetAnnouncements")();

// The session's first fetch settled or took too long; auto-running guides stop waiting for it.
export const endStartupWait = createAction("@announcements/endStartupWait")();

// An announcement CTA opened this tab: it fetches and shows nothing until sign-out.
export const suppressAnnouncements = createAction("@announcements/suppressAnnouncements")();

export const markAnnouncementViewed = createAsyncAction(
  "@announcements/markAnnouncementViewed/request",
  "@announcements/markAnnouncementViewed/success",
  "@announcements/markAnnouncementViewed/failure"
)<Announcement["id"], Announcement["id"], void>();

export type Actions = ActionType<
  | typeof endStartupWait
  | typeof fetchAnnouncements
  | typeof hideAnnouncements
  | typeof markAnnouncementViewed
  | typeof openAnnouncements
  | typeof postponeAnnouncement
  | typeof resetAnnouncements
  | typeof showNextAnnouncement
  | typeof skipAnnouncements
  | typeof suppressAnnouncements
  | typeof triggerAnnouncements
>;
